const SATELLITE_TILE_JSON_URL =
  'https://api.maptiler.com/tiles/satellite/tiles.json';

const MAPTILER_ATTRIBUTION =
  '<a href="https://www.maptiler.com/copyright/">© MapTiler</a>';

export const createSatelliteMapStyle = (apiKey: string) => ({
  version: 8 as const,
  sources: {
    'maptiler-satellite': {
      type: 'raster' as const,
      url: `${SATELLITE_TILE_JSON_URL}?key=${encodeURIComponent(apiKey)}`,
      attribution: MAPTILER_ATTRIBUTION,
    },
  },
  layers: [
    {
      id: 'maptiler-satellite',
      type: 'raster' as const,
      source: 'maptiler-satellite',
    },
  ],
});
